import { show, hide, trigger } from './utility';

/// validation-summary is used to add click event to the links

/// <div data-gs-toggle="validation-summary"><a data-gs-target="name_of_target"></div>

export default function (targetElem: HTMLElement) {
    let alinks = targetElem.querySelectorAll('a[data-gs-target]');
    for (let i = 0; i < alinks.length; ++i) {
        let alinkElem = alinks[i] as HTMLLinkElement;
        let targetName = alinkElem.dataset['gsTarget'];
        let targetElems = document.getElementsByName(targetName);
        if (targetElems.length == 0) {
            console.log(`can not find validation target: ${targetName}`);
        }

        alinkElem.addEventListener('click', (e) => {
            e.preventDefault();
            let alinkElem = e.target as HTMLLinkElement;
            let targetName = alinkElem.dataset['gsTarget'];
            let targetElems = document.getElementsByName(targetName);
            let targetElem;
            if (targetElems && targetElems.length > 0) {
                targetElem = targetElems[0]
            } else {
                targetElem = document.getElementById(targetName);
            }
            if (!targetElem) {
                console.warn('validation-summary can not find target:', targetName)
                return;
            }
            let offset = targetElem.getClientRects()[0]['top'] - 70;
            window.scrollTo({ top: offset, behavior: 'smooth' })
        });
    }
}